var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "-1 -1 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM5.71429 20C5.71429 12.1102 12.1102 5.71429 20 5.71429C22.9329 5.71429 25.6594 6.59811 27.9277 8.11397L8.11397 27.9277C6.59811 25.6594 5.71429 22.9329 5.71429 20ZM12.1709 31.9514C14.4193 33.4274 17.1093 34.2857 19.9997 34.2857C27.8894 34.2857 34.2854 27.8897 34.2854 20C34.2854 17.1096 33.4271 14.4197 31.9511 12.1713L12.1709 31.9514Z",
    fill: "white",
    strokeWidth: 2,
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.07e36caab8deeb8e027d32ba3655af0a.svg";
export { ForwardRef as ReactComponent };